import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconMenu3 = ({ title, titleId,...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "28px",
	height: "44px",
	viewBox: "0 0 28 44",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "Material-Design-Stickersheet",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		fontFamily: "Raleway-Medium, Raleway",
		fontSize: 60,
		fontWeight: 400,
		children: /* @__PURE__ */ _jsx("g", {
			id: "Genus:-Nominativ-I",
			transform: "translate(-23.000000, -346.000000)",
			fill: "#FFFFFF",
			children: /* @__PURE__ */ _jsx("text", {
				id: 3,
				children: /* @__PURE__ */ _jsx("tspan", {
					x: 21,
					y: 381,
					children: "3"
				})
			})
		})
	})]
});
const ForwardRef = forwardRef(SvgIconMenu3);
export { ForwardRef as ReactComponent };
